import axios, { AxiosRequestConfig } from 'axios';
import SessionService from './SessionService';

const Axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

Axios.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = SessionService.getSession();
    if (token) {
        config.headers.Authorization =  `Bearer ${token}`;
    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }
    return config;
});

export default Axios;
